import React from 'react';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    containerClassName?: string;
    variant?: 'bordered' | 'ghost';
    textAreaSize?: 'xs' | 'sm' | 'md' | 'lg';
    color?: 'primary' | 'secondary' | 'accent' | 'info' | 'success' | 'warning' | 'error';
}

export function TextArea({
    label,
    className = "",
    containerClassName = "",
    variant = 'bordered',
    textAreaSize,
    color,
    ...props
}: TextAreaProps) {
    const baseClass = "textarea w-full rounded-lg";

    // Variant styles (textareas are bordered by default in daisyUI 5)
    let variantClass = "";
    if (variant === "bordered") variantClass = "border-base-content/20";
    else if (variant === "ghost") variantClass = "textarea-ghost";

    // Size styles
    let sizeClass = "";
    if (textAreaSize === "xs") sizeClass = "textarea-xs";
    else if (textAreaSize === "sm") sizeClass = "textarea-sm";
    else if (textAreaSize === "lg") sizeClass = "textarea-lg";

    // Color styles
    let colorClass = "";
    if (color === "primary") colorClass = "textarea-primary";
    else if (color === "secondary") colorClass = "textarea-secondary";
    else if (color === "accent") colorClass = "textarea-accent";
    else if (color === "info") colorClass = "textarea-info";
    else if (color === "success") colorClass = "textarea-success";
    else if (color === "warning") colorClass = "textarea-warning";
    else if (color === "error") colorClass = "textarea-error";

    const classes = [
        baseClass,
        variantClass,
        sizeClass,
        colorClass,
        className
    ].filter(Boolean).join(" ");

    return (
        <div className={`flex flex-col gap-1 ${containerClassName}`}>
            {label && <label className="label">{label}</label>}
            <textarea
                className={classes}
                {...props}
            />
        </div>
    );
}
